import { promiseFetchDataAuth, delaySave, removeChildArray } from 'crk-front-lib';

const APIPATH = '/api/v2';
const DELAY_TIME = 1250;

export function performSearch(filter) {
  return promiseFetchDataAuth(`${APIPATH}/work-orders`);
}

export function read(id) {
  /* Using promise.all takes very long time
  const tasks = [readWork(id), readSpec(id), readFormula(id), readProcess(id), readJob(id)];

  return Promise.all(tasks).then((values) => {
    // console.info(values);

    const data = values[0];
    data.specs = values[1];
    data.formulas = values[2];
    data.process = values[3];
    data.jobs = values[4];

    return data;
  });
  */
  return readWork(id)
  .then(data => {
    return data;
  })
}

export function readWork(id) {
  // fetch then return json.data
  return promiseFetchDataAuth(`${APIPATH}/work-orders/${id}`);
}

export function readSpec(id) {
  // fetch then return json.data
  return promiseFetchDataAuth(`${APIPATH}/work-specs?work_id=${id}`);
}

export function readFormula(id) {
  // fetch then return json.data
  return promiseFetchDataAuth(`${APIPATH}/work-boms?work_id=${id}`);
}

export function readProcess(id) {
  // fetch then return json.data
  return promiseFetchDataAuth(`${APIPATH}/work-process?work_id=${id}`);
}

export function readJob(id) {
  // fetch then return json.data
  return promiseFetchDataAuth(`${APIPATH}/work-jobs?work_id=${id}`);
}

export function delaySaveWork(data) {
  return delaySave(
    `${APIPATH}/work-orders` + (data._id ? `/${data._id}` : ''),
    data._id ? 'PUT' : 'POST',
    removeChildArray(data),
    DELAY_TIME,
    'save_work'
  );
}

export function removeWork(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-orders/${id}`, 'DELETE');
}

export function delaySaveSpec(work_id, data) {
  data.work_id = work_id; // Ensure work_id

  return delaySave(
    `${APIPATH}/work-specs` + (data._id ? `/${data._id}` : ''),
    data._id ? 'PUT' : 'POST',
    removeChildArray(data),
    DELAY_TIME,
    'save_spec'
  );
}

export function delaySaveBom(work_id, data) {
  data.work_id = work_id; // Ensure work_id

  return delaySave(
    `${APIPATH}/work-boms` + (data._id ? `/${data._id}` : ''),
    data._id ? 'PUT' : 'POST',
    removeChildArray(data),
    DELAY_TIME,
    'save_bom'
  );
}

export function delaySaveProcess(work_id, data) {
  data.work_id = work_id; // Ensure work_id

  return delaySave(
    `${APIPATH}/work-process` + (data._id ? `/${data._id}` : ''),
    data._id ? 'PUT' : 'POST',
    removeChildArray(data),
    DELAY_TIME,
    'save_process'
  );
}

export function delaySaveJob(work_id, data) {
  data.work_id = work_id; // Ensure work_id

  return delaySave(
    `${APIPATH}/work-jobs` + (data._id ? `/${data._id}` : ''),
    data._id ? 'PUT' : 'POST',
    removeChildArray(data),
    DELAY_TIME,
    'save_job'
  );
}

export function removeSpec(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-specs/${id}`, 'DELETE');
}

export function removeBom(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-boms/${id}`, 'DELETE');
}

export function removeProcess(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-process/${id}`, 'DELETE');
}

export function removeJob(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-jobs/${id}`, 'DELETE');
}

export function copyWork(id) {
  return promiseFetchDataAuth(`${APIPATH}/work-orders/copy/${id}`, 'POST');
}

export function fetchCountOrder({period, status}) {
  let url = `${APIPATH}/work-reports/count-order?due=${period}`;
  if (status) url += `&status=${status}`;

  return promiseFetchDataAuth(url);
}

export function fetchSumProduced({period, group}) {
  let url = `${APIPATH}/work-reports/sum-produced?finish=${period}`;
  if (group) url += `&group=${group}`;

  return promiseFetchDataAuth(url);
}

export function fetchDashData() {
  let url = `${APIPATH}/work-reports/dashdata`;

  return promiseFetchDataAuth(url);
}
